import { render, staticRenderFns } from "./yesAvatar.vue?vue&type=template&id=a5c45e42"
import script from "./yesAvatar.vue?vue&type=script&lang=js"
export * from "./yesAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports